import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { billingClient } from '/lib/clients';
import { BillingProvider } from '/imports/checkout/api/useBilling';
import Footer from '/imports/core/ui/components/Footer';
import { getDomainFromHost } from '/lib/helpers';
import Header from '/imports/dashboard/ui/components/Header';
import RefundSubscriptionPolicy from '/imports/refundPolicy/ui/pages/RefundSubscriptionPolicy';
import withAccountInfo from '/imports/core/api/accounts/withAccountInfo';
import { withIntl } from '/imports/core/api/useIntl';
import { withResponsiveContext } from '/imports/core/api/responsiveContext';
import { withTracking } from '/imports/core/hooks/useTracking';
import absoluteUrl from 'next-absolute-url';
import { getCountry } from 'imports/checkout/api/utils';
import { getLBRules } from 'imports/checkout/api/helpers';

@withTracking
@withAccountInfo
@withIntl
@withResponsiveContext
class RCPolicyPage extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
    pageProps: PropTypes.object,
    router: PropTypes.object,
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('cancelation_policy_view');
  }
  render() {
    const { query } = this.props.router;
    return (
      <BillingProvider
        value={billingClient}
        specialPlanId={query.specialPlanId}
        withLoading
        rule={this.props.pageProps.rule}
      >
        <ContentWrapper>
          <Header showDashboard gilroy />
          <RefundSubscriptionPolicy />
          <Footer />
        </ContentWrapper>
      </BillingProvider>
    );
  }
}

RCPolicyPage.getInitialProps = async (ctx) => {
  try {
    const { host } = absoluteUrl(ctx.req);
    const country = getCountry();
    const domain = getDomainFromHost(host);
    const rule = await getLBRules(domain, country);
    return { rule };
  } catch (e) {
    return { rule: [] };
  }
};
export default RCPolicyPage;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  transition: filter 0.2s;
  position: absolute;
  font-family: ${({ theme }) => theme.font.family.websiteRegular};
  font-size: 1.6rem;
  line-height: 1.35;
  font-weight: 400;
`;
